export const FILE_MAXIMUM_SIZE = 307200;
